/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_Admin_TitleInputs */



/**
* | output |
* | --- |
* | "Presentation templates" |
*
* @param {Presentation_Templates_Admin_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_admin_title = /** @type {((inputs?: Presentation_Templates_Admin_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_Admin_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Präsentationsvorlagen")
	return /** @type {LocalizedString} */ ("Presentation templates")
});